import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { IssueLinksStats as IssueLinksStatsPopup } from './ui/index.tsx';
import type { IssueLinksStatsProps } from './ui/types.tsx';

export const IssueLinksStats = (props: IssueLinksStatsProps) => (
	<JSErrorBoundary
		id="jira-issue-links-stats"
		packageName="jiraIssueLinksStats"
		teamName="jira-werewolves"
		fallback="unmount"
	>
		<IssueLinksStatsPopup {...props} />
	</JSErrorBoundary>
);
